if (!customElements.get('featured-products-slider')) {
  class FeaturedProductsSlider extends HTMLElement {
    connectedCallback() {
      this.#init();
    }

    #init() {
      // swiper-bundle.min.js loads with defer before this file, but guard anyway
      if (!window.Swiper) {
        if ((this.retries = (this.retries || 0) + 1) < 40) setTimeout(() => this.#init(), 50);
        return;
      }

      this.views = [...this.querySelectorAll('.fp-slider__view')];
      this.panels = [...this.querySelectorAll('[data-view-panel]')];
      this.slides = [...this.querySelectorAll('.fp-card')];

      // Slide counts and gutters mirror assets/grid.css, so every slide lands on a
      // whole number of columns: with n slides and the grid's own gutter between
      // them, (cols*c + (cols-1)*g) - (n-1)*g divides evenly by n. The tiers are
      // the same one-up → four-up steps the collection grid uses.
      //
      //   below 550   1 up   4 of 4 mobile columns, 16px gutter
      //   550-749     2 up   2 of 4
      //   750-989     3 up   4 of 12 desktop columns, 24px gutter
      //   990+        4 up   3 of 12
      const breakpoints = {
        0: { slidesPerView: 1, spaceBetween: 16 },
        550: { slidesPerView: 2, spaceBetween: 16 },
        750: { slidesPerView: 3, spaceBetween: 24 },
        990: { slidesPerView: 4, spaceBetween: 24 },
      };

      this.swiper = new window.Swiper(this.querySelector('.swiper'), {
        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints,
        grabCursor: true,
        navigation: {
          prevEl: this.querySelector('[data-slider-prev]'),
          nextEl: this.querySelector('[data-slider-next]'),
          disabledClass: 'swiper-button-disabled',
        },
      });

      this.views.forEach((btn) => {
        btn.addEventListener('click', () => this.#selectView(btn.dataset.view));
      });

      this.panels.forEach((panel) => {
        panel.querySelectorAll('.fp-slider__filter').forEach((tab) => {
          tab.addEventListener('click', () => this.#selectFilter(panel, tab));
        });
      });

      // Apply the initial filter (first tab of the visible view), if any
      this.#applyActiveFilter();
    }

    #selectView(view) {
      this.views.forEach((btn) => btn.setAttribute('aria-selected', btn.dataset.view === view ? 'true' : 'false'));
      this.panels.forEach((panel) => (panel.hidden = panel.dataset.viewPanel !== view));
      // Switching views clears any filter: deselect every tab and show all products
      this.querySelectorAll('.fp-slider__filter').forEach((t) => t.setAttribute('aria-selected', 'false'));
      this.#applyActiveFilter();
    }

    #selectFilter(panel, tab) {
      // Exclusive: selecting a filter deselects every other filter in both views
      this.querySelectorAll('.fp-slider__filter').forEach((t) => {
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      this.#applyActiveFilter();
    }

    #applyActiveFilter() {
      const panel = this.panels.find((p) => !p.hidden);
      const active = panel?.querySelector('.fp-slider__filter[aria-selected="true"]');

      if (active) {
        const key = panel.dataset.viewPanel; // 'vendor' | 'varietal'
        const value = active.dataset.filter;

        this.slides.forEach((slide) => {
          // data-varietal can hold several comma-separated values; match any of them
          const values = (slide.dataset[key] || '').split(', ');
          slide.style.display = values.includes(value) ? '' : 'none';
        });
      } else {
        // No filter selected: show everything
        this.slides.forEach((slide) => (slide.style.display = ''));
      }

      this.swiper.update();
      this.swiper.slideTo(0, 0);
    }
  }

  customElements.define('featured-products-slider', FeaturedProductsSlider);
}
